<template>
  <v-dialog
    v-model="dialog"
    persistent
    max-width="290px"
    @keydown.esc="closeDialog"
  >
    <v-card>
      <div
        style="width: 280px; height: 180px;"
      >
        <div>
          <h3 class="popup-title" style="height: 60px; line-height: 60px;">회의 저장</h3>
        </div>
        <div style="display: flex; justify-content: center;">
          <input
            class="form-control"
            type="text"
            placeholder="회의명을 입력하세요"
            v-model="bookmarkTitle"
            style="width: 85%; height: 35px"
          />
        </div>
        <div class="btnArea" style="justify-content: center; margin-top:10px;">
          <button class="noIconButton" @click="closeDialog()">
            닫기
          </button>

          <button class="btnPrimary" @click="createMeetingBookmark()">
            저장
          </button>
        </div>
      </div>
    </v-card>
  </v-dialog>
</template>
<script>
import Util from "@/util";

export default {
  components: {},
  props: ["dialog", "meetingInfo", "closeDialog"],
  data() {
    return {
      loading: true,
      error: null,
      bookmarkTitle: "",
    };
  },
  watch: {
    dialog: {
      handler(val) {
        this.loading = false;
        this.error = null;
      },
    },
  },
  methods: {
    init() {
      this.error = null;
      this.bookmarkTitle = "";
    },
    close() {
      this.init();
      this.closeDialog();
    },
    async createMeetingBookmark () {
      if (this.bookmarkTitle === "" || this.bookmarkTitle === null) {
        this.error = "회의명이 입력되지 않았습니다.";
        return;
      }

      this.meetingInfo["bookmarkTitle"] = this.bookmarkTitle;

      await this.$http
        .post("/api/v1/meetings/meeting_bookmark", this.meetingInfo)
        .then(response => {
          let ret = response.data;
          console.log(ret);
          let meetingInfo = response.data;
          if (ret === "ok") {
            this.close();
            Util.snackBarOpen("회의 저장 완료", "success");
          } else {
            this.error = meetingInfo;
          }
        })
        .catch(error => {
          this.error = error.response.data.error;
        });
    },
  },
};
</script>
<style scoped>
.dialog-container {
  width: 350px;
  box-shadow: 1px 1px 18px 0px rgba(50, 50, 50, 0.37);
}
.invite-btn {
  background-color: #604af3;
  color: white;
  width: 100px;
  height: 48px;
  border-radius: 8px;
  margin: 0 5px;
  font-size: 15px;
}
.close-btn {
  width: 100px;
  height: 48px;
  border-radius: 8px;
  background: #f2f2f2;
  color: #1f2e3d;
  margin: 0 5px;
  font-size: 15px;
}

.desc {
  font-size: 14px;
  text-align: center;
  margin: 30px 0 18px 0;
}
.add_name {
  color: #604af3;
  font-weight: 500;
}

.btnArea {
  justify-content: center;
}

.btnArea button:hover {
  opacity: 0.7;
}
</style>



// WEBPACK FOOTER //
// src/components/popup/AddBookmarkMeetingDialog.vue